import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from "./Services/UserContext";
import Preloader from "./Helper/Preloader"; // import your Preloader
import ExcelUploader from "./Forms/Upload";
import Images from "./Forms/Images"; // Importing the Images component

// Lazy load all components
const HomePage = lazy(() => import("./Components/HomePage"));
const ProductsDetails = lazy(() => import("./Components/ProductsDetails"));
const CreateUser = lazy(() => import("./Forms/CreateUser"));
const LoginPage = lazy(() => import("./Pages/LoginPage."));
const ShopPage = lazy(() => import("./Pages/ShopPage"));
const Pro = lazy(() => import("./Api/NewArrival"));
const AddToCart = lazy(() => import("./Pages/AddToCart"));
const CheckoutPage = lazy(() => import("./Pages/CheckoutPage"));
const ProductItem = lazy(() => import("./Components/Categoyrnames"));
const BillPage = lazy(() => import("./Pages/BillPage"));
const ShopDetials = lazy(() => import("./Pages/ShopDetials"));
const Register = lazy(() => import("./Pages/Regiseter"));
const Category = lazy(() => import("./Pages/CategoyrNameDetials"));
const MyProfile = lazy(() => import("./Forms/MyProfile"));
// Fallback Loader during lazy load
const Loader = () => <Preloader></Preloader>;

function App() {
  const [isAppLoading, setAppLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setAppLoading(false), 1000); // Simulate preload
    return () => clearTimeout(timer);
  }, []);

  return (
    <UserProvider>
      <Router>
        {isAppLoading ? (
          <Preloader />
        ) : (
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<CreateUser />} />
              <Route path="/product/:id" element={<ProductsDetails />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/practice" element={<Pro />} />
              <Route path="/add" element={<AddToCart />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/item" element={<ProductItem />} />
              <Route path="/Bill" element={<BillPage />} />
              <Route path="/shopDetail" element={<ShopDetials />} />
              <Route path="/user" element={<Register />} />
              <Route path="/moreProducts" element={<ShopDetials />} />
              <Route path="/moreCategoryProduct" element={<Category />} />
              <Route path="/myprofile" element={<MyProfile />} />
              <Route path="/up" element={<ExcelUploader />} />
              <Route path="/up2" element={<Images />} />
            </Routes>
          </Suspense>
        )}
      </Router>
    </UserProvider>
  );
}

export default App;
